import { useMutation } from "@tanstack/react-query";
import api from "../../../api";
import { toast } from "react-toastify";
import { toastStyles } from "../../../styles/styles";
import { PAGE_CONFIG } from "../config";

export const useCreateTimeline = (queryClient, theme, onSuccessCallback) => {
    const { mutate: createTimeline, status: createStatus, isPending: isCreating } = useMutation({
        mutationFn: (data) => {
            console.log('data--->', data);
            return api.timeline.createTimeline(data);
        },
        onSuccess: (data) => {
            toast.success(data?.message || 'Timeline created successfully', { ...toastStyles, theme: theme });
            queryClient.invalidateQueries([PAGE_CONFIG.GET_QUERY_KEY]);
            onSuccessCallback && onSuccessCallback();
        },
        onError: (error) => {
            toast.error(error?.response?.data?.message || 'Timeline creation failed', { ...toastStyles, theme: theme });
        }
    });

    return { createTimeline, isCreating, createStatus };
};